import {
  SearchInput,
  SEARCH_INPUT_VARIANT,
} from "@volca/ui/components/ui/search-input";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import type {
  IPackChatTechnicianGroup,
  IPackChatThreadOverview,
} from "@/payroll/pack-chat/types";
import { PackChatTechnicianRow } from "./pack-chat-technician-row";
import {
  PackChatThreadFilter,
  THREAD_FILTER,
  type ThreadFilter,
} from "./pack-chat-thread-filter";

export const PackChatTechnicianList = ({
  starting,
  search,
  onSearchChange,
  filter,
  counts,
  onFilterChange,
  groups,
  activeTechnicianId,
  onSelectTechnician,
}: {
  starting: boolean;
  search: string;
  onSearchChange: (next: string) => void;
  filter: ThreadFilter;
  counts: IPackChatThreadOverview["counts"] | undefined;
  onFilterChange: (next: ThreadFilter) => void;
  groups: IPackChatTechnicianGroup[];
  activeTechnicianId: string | null;
  onSelectTechnician: (technicianId: string) => void;
}) => (
  <Stack
    gap={0}
    align="stretch"
    className={cn("min-h-0 min-w-0 md:border-r md:border-line", {
      hidden: starting,
    })}
  >
    <Stack
      direction="row"
      gap={2}
      align="center"
      className="shrink-0 border-b border-line px-5 py-2"
    >
      <SearchInput
        variant={SEARCH_INPUT_VARIANT.bare}
        value={search}
        onChange={onSearchChange}
        placeholder="Search threads"
      />
    </Stack>
    <Stack
      gap={0}
      align="stretch"
      className="shrink-0 px-5 pt-3 pb-2 lg:px-3 min-[90rem]:px-5"
    >
      <PackChatThreadFilter
        value={filter}
        counts={{
          [THREAD_FILTER.all]: counts?.all ?? 0,
          [THREAD_FILTER.open]: counts?.open ?? 0,
          [THREAD_FILTER.closed]: counts?.closed ?? 0,
        }}
        onChange={onFilterChange}
      />
    </Stack>
    <div className="min-h-0 w-full flex-1 overflow-y-auto">
      {/* The inset rides inside the scroll, like the other panes: the rows
          then run to the card's edge as you scroll and still clear it at the
          end of the list. */}
      <Stack
        align="start"
        gap={0}
        className="w-full min-w-0 divide-y divide-line pb-5"
      >
        {groups.map((group) => (
          <PackChatTechnicianRow
            key={group.technician.id}
            group={group}
            selected={!starting && group.technician.id === activeTechnicianId}
            onSelect={() => onSelectTechnician(group.technician.id)}
          />
        ))}
      </Stack>
    </div>
  </Stack>
);
